<template>
	<div>
		<orders
			:headers="headers"
			:rows="rows"
			:status="status"
			:headers-mobile="headersMobile"
			:currentStatus="currentStatus"
			@close-modal="closeModal"
			@change-tab="changeTab"
			@detail="orderDetail"
			@cancel="cancelOrder"
			@deposit="depositData"
		/>
		<el-dialog 
			class="warehouse-pickup-modal modal-cancel"
			:visible="modal"
			@close="closeCancel"
			title="Anular Pedido">
			<div class="wrapper-body-cancel">
				<span>¿Está seguro de anular el pedido?</span>
			</div>
			<div slot="footer" class="d-flex align-center justify-center">
			<button
				class="ok-btn"
				type="button"
				@click="confirmationCancel"
			>Aceptar</button>
		</div>
		</el-dialog>
	</div>
</template>
<script>
import orders from '@/components/profile/orders';
import format from 'date-fns/format';
import lib from '@/helpers/lib';
import { deposit } from '@/shared/enums/wayPayment';

const { getDeeper } = lib;

function created() {
	this.loadOrders();
	this.loadStates();
}

async function loadStates() {
	const token = this.$store.getters.token;
	const headers = {
		Authorization: `Bearer ${token}`,
	};
	const requests = [
		this.$httpJapi.get('order-states', { headers }),
		this.$httpJapi.get('orders', { headers }),
	];
	([
		{ data: this.status },
		{ data: this.ordersTotal },
	] = await Promise.all(requests));
	const initial = this.status.filter(s => s.flagInit === 1);
	[this.statusInitial] = initial;
	this.orders[0].quantity = this.ordersTotal.filter(o => o.paymentStateId === 1).length;
	this.orders[1].quantity = this.ordersTotal.filter(o => o.paymentStateId === 3).length;
	this.orders[2].quantity = this.ordersTotal.filter(o => o.paymentStateId === 2).length;
	this.status = [].concat(this.allOrders, this.status.filter(s => s.name !== 'Anulado'));
	this.currentStatus = this.status[0].id;
}

async function loadOrders(id) {
	const { token } = this.$store.getters;
	const headers = {
		Authorization: `Bearer ${token}`,
	};
	const params = {
		orderStateId: id === -1 ? null : id,
	};
	const requests = [
		this.$httpJapi.get('orders', { headers, params }),
	];
	([
		{ data: this.rows },
	] = await Promise.all(requests));
	this.rows = this.rows.map((row) => {
		const newRow = {};
		newRow.date = this.exactDate(row.createdAt, 'DD/MM/YYYY');
		newRow.order = row.number;
		newRow.total = row.total;
		newRow.status = row.paymentStateName;
		newRow.pickUpName = row.pickUpName;
		newRow.method = getDeeper('wayPayment.name')(row) || '--';
		newRow.orderStatus = row.orderState.name;
		newRow.action = 'action';
		newRow.id = row.id;
		const code = getDeeper('wayPayment.code')(row);
		const status = getDeeper('orderState.name')(row);
		newRow.voucher = code === deposit.code && status === 'Solicitado';
		return newRow;
	});
}


function closeModal() {
	this.$emit('close-modal');
}

function changeTab(statusId) {
	const id = typeof statusId === 'number' ? statusId : statusId.id;
	this.currentStatus = id;
	this.loadOrders(id);
}

function depositData(id) {
	this.$router.push({ name: 'order-deposit', params: { id } });
}

function orderDetail(id) {
	this.$router.push({ name: 'order-details', params: { id } });
}

function cancelOrder(id) {
	this.modal = true;
	this.idCancel = id;
}

function closeCancel() {
	this.modal = false;
	this.idCancel = null;
}

async function confirmationCancel() {
	const token = this.$store.getters.token;
	const headers = {
		Authorization: `Bearer ${token}`,
	};
	try {
		await this.$httpJapi.patch(`orders/${this.idCancel}/cancel`, null, { headers });
		this.$message.success({ message: 'Se anuló el pedido', showClose: true });
		this.loadOrders(this.statusInitial.id);
		this.closeCancel();
	} catch (error) {
		this.$message({
			message: 'Error',
			showClose: true,
			type: 'error',
		});
	}
}

function exactDate(date, formatter = 'DD-MM-YYYY', splitBy = 'T') {
	if (date) {
		const dateSplit = date.split(splitBy);
		const dateComplete = dateSplit[0].split('-');
		const year = dateComplete[0];
		const month = dateComplete[1] - 1;
		const day = dateComplete[2];
		const newDate = format(new Date(year, month, day), formatter);
		return newDate;
	}
	return '';
}

function data() {
	return {
		allOrders: { id: -1, name: 'Todos' },
		currentStatus: {},
		headers: [
			{ name: 'FECHA DE ORDEN', id: 1 },
			{ name: 'NÚMERO DE ORDEN', id: 2 },
			{ name: 'TOTAL DE ORDEN', id: 3 },
			{ name: 'ESTADO PAGO', id: 4 },
			{ name: 'MODO DE ENTREGA', id: 5 },
			{ name: 'METODO DE PAGO', id: 6 },
			{ name: 'ESTADO', id: 7 },
			{ name: 'ACCIÓN', id: 8 },
		],
		headersMobile: [
			{ name: 'FECHA', id: 9 },
			{ name: 'ESTADO', id: 10 },
			{ name: 'METODO DE PAGO', id: 11 },
		],
		orders: [
			{
				name: 'No pagado',
				quantity: 5,
			},
			{
				name: 'Pagado',
				quantity: 0,
			},
			{
				name: 'Pago Parcial',
				quantity: 0,
			},
		],
		ordersTotal: [],
		params: {
			orderStateId: '2',
		},
		paymentState: [
			{ id: 1, code: 'pending', name: 'No Pagado' },
			{ id: 2, code: 'partial', name: 'Parcial' },
			{ id: 3, code: 'payOut', name: 'Pagado' },
		],
		rows: [],
		status: [],
		statusInitial: {},
		modal: false,
		idCancel: null,
	};
}

export default {
	name: 'list',
	components: {
		orders,
	},
	created,
	data,
	methods: {
		changeTab,
		closeModal,
		depositData,
		exactDate,
		loadOrders,
		loadStates,
		orderDetail,
		cancelOrder,
		closeCancel,
		confirmationCancel,
	},
};
</script>
<style lang="scss">
	.modal-cancel {
		.el-dialog {
			width: 38%;
		}

		.ok-btn {
			background-color: color(defaultOrange);
			border: none;
			color: white;
			font-size: size(large);
			padding: 0.75rem 3rem;
		}

		.wrapper-body-cancel {
			font-size: size(normal);
			padding: 4rem 2rem;
		}
	}

	.profile {
		.el-dialog__wrapper {
			align-items: center;
			display: flex;
		}
	}
</style>




// WEBPACK FOOTER //
// list.vue?2ea6808d